import { memo, useState } from "react";

// Helpers
import { useTranslate } from "helpers";

// UI
import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";

import { NjuskaloEditCardProps } from "./types";
import { useHandleTextFieldChange } from "services/forms/hooks";
import { Errors } from "services/forms/validation/types";
import { NJUSKALO_EDIT_FORM_SCHEMA } from "./validation";
import { validateYup } from "services/forms/validation/validation";

const NjuskaloEditCard: React.FC<NjuskaloEditCardProps> = (props) => {
  const { settings, setSettings, onSuccess, onClose } = props;

  const { t } = useTranslate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<Errors>({});

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();

    const isValid = validateYup(
      settings,
      NJUSKALO_EDIT_FORM_SCHEMA,
      setErrors
    );

    if (!isValid) {
      return;
    }

    setIsLoading(true);

    try {
      // TODO: Add API call to save settings
      if (onSuccess) onSuccess();
    } catch (e) {
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
  };

  const handleTextFieldChange = useHandleTextFieldChange(
    setSettings,
    settings
  );

  return (
    <>
      <div className="flex gap-4">
        <div className="w-full m-auto">
          <div className="flex gap-3 h-full">
            <form noValidate className="text-left flex-1 " onSubmit={handleFormSubmit}>
              <div className="p-4">
                <div className="mb-3">
                  <TextField
                    type="text"
                    name="username"
                    label={t("admin.integration.njuskalo.username")}
                    placeholder={t("admin.integration.njuskalo.username.placeholder")}
                    onChange={handleTextFieldChange}
                    value={settings.username}
                    error={errors.username}
                    required
                  />
                </div>
                <div className="mb-3">
                  <TextField
                    type="password"
                    name="password"
                    label={t("admin.integration.njuskalo.password")}
                    placeholder={t("admin.integration.njuskalo.password.placeholder")}
                    onChange={handleTextFieldChange}
                    value={settings.password}
                    error={errors.password}
                    required
                  />
                </div>
              </div>
              <div className="px-4 py-3 fixed left-0 bottom-0 bg-slate-50 border border-t-slate-200 w-full flex justify-end gap-3">
                <Button
                  variant="outlined"
                  children={t("admin.close")}
                  onClick={() => onClose()}
                />
                <Button
                  variant="primary"
                  children={t("admin.save")}
                  type="submit"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(NjuskaloEditCard);
